import ChangeLogComponent from "../components/changelogcomponents/changlogcomponent"

const ChangeLogPage = ()=>{
    return(<ChangeLogComponent/>)
}
export default ChangeLogPage